import React from 'react'
import { FAQPage } from 'schema-dts'
import { JsonLd } from 'react-schemaorg'

class FAQ extends React.Component {

  render() {
    const { items } = this.props

    const mainEntityItems = []

    items.forEach(item => {
      mainEntityItems.push(
        {
          '@type': 'Question',
          'name': item.question,
          'acceptedAnswer': {
            '@type': 'Answer',
            'text': item.answer,
          },
        },
      )
    })

    function createMarkup(html) {
      return {__html: html};
    }

    return (
      <div>



        {items.map(item => <div>
          <h3>{item.question}</h3>
          <p dangerouslySetInnerHTML={createMarkup(item.answer)}></p>
        </div>)}


        <JsonLd
          item={{
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: mainEntityItems,
          }}/>

      </div>
    )
  }
}

export default FAQ
